import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ButtonLoader, Checkbox, Input, SelectInput } from "components/__new/common/form";
import TabSettings from "components/__new/common/TabSettings";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
import { ReactComponent as IconsPlus } from "assets/images/icons/project-icons/Plus.svg";
// import PageContent from "components/__new/common/PageContent";
import FormDrawer from "components/__new/common/form-drawer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import validate from "utils/validate";
import { toast } from "react-toastify";
import Maybe from "components/__new/common/Maybe";
import numberOrdinalSuffix from "utils/numberOrdinalSuffix";
import { weekdays } from "utils/dateFormat";
import moment from "moment";
import PageContent from "components/__new/common/PageContent";
import Environment from "components/__new/common/Environment";
import useEnvironment from "hooks/useEnvironment";
import * as payrollAction from "store/entities/payroll/runPayroll/action";
import * as payrollSetupAction from "store/entities/payroll/payrollSetup/action";
import logger from "utils/logger";
import useLoginInfo from "hooks/useLoginInfo";


const Index = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {isEnvironment} = useEnvironment();
    const {userInfo} = useLoginInfo();
    
    
    const {createPayroll, createPayrollLoading} = useSelector((s) => s.entities.runPayroll);
    const {
        getPayScheduleData: paySchedules, getPayScheduleLoading: paySchedulesLoading,
        getPayGroupData: payGroups, getPayGroupLoading: payGroupsLoading,
    } = useSelector((s) => s.entities.payrollSetup);


    const [isOpenPayGroups, setIsOpenPayGroups] = useState(false);
    const [form, setForm] = useState({
        monthYear: {
            month: "",
            monthIndex: "",
            year: "",
            fullDate: null,
        },
        payGroup: [],
        payrollType: "",
        paySchedule: "",
    })


    const renderMonthContent = (month, shortMonth, longMonth) => {
        const tooltipText = `Tooltip for month: ${longMonth}`;
        return <span title={tooltipText}>{shortMonth}</span>;
    };


    const monthYearSelection = (date) => {
        if (date && date !== ""){
            const data = {
                month: moment(date).format('MMMM'),
                monthIndex: moment(date).format('M'),
                year: moment(date).format('yy'),
                fullDate: date,
            }
            setForm({...form, monthYear: data})
        }
        else{
            setForm({
                ...form,
                monthYear: {
                    month: "",
                    monthIndex: "",
                    year: "",
                    fullDate: null,
                }
            })
        }
    };


    const addPayGroup = (payGroup) => {
        const formPayGroup = form.payGroup?.filter(data => data.id === payGroup.id)
        if (formPayGroup.length === 0){
            setForm({
                ...form,
                payGroup: [
                    ...form.payGroup,
                    payGroup,
                ],
            });
            setIsOpenPayGroups(false);
        }
        else{
            toast.error("This pay group has already been added");
        }
    };


    const removePayGroup = (payGroup) => {
        const newFormPayGroup = form.payGroup?.filter(data => data.id !== payGroup.id)
        setForm({...form, payGroup: newFormPayGroup});
    };


    const getPayGroups = () => {
        const params = {"page": 1, "limit": 1000};
        dispatch(payrollSetupAction.getPayGroups(params));
    }


    const getPayrollSchedules = () => {
        const params = {"page": 1, "limit": 1000};
        dispatch(payrollSetupAction.getPaySchedule(params));
    }


    const getPayScheduleFrequency = (paySchedule) => {
        const payScheduleFrequencyObject = paySchedule?.frequency;
        const payScheduleFrequency = payScheduleFrequencyObject?.payroll_frequency;
        const payScheduleFrequencies = {
            "MONTHLY": "Monthly",
            "BI_MONTHLY": "Bi-Monthly",
            "WEEKLY": "Weekly",
        }

        const frequency = payScheduleFrequencies[payScheduleFrequency];
        let payMode = "";

        if (payScheduleFrequency === "MONTHLY"){
            payMode = "on the " + numberOrdinalSuffix(payScheduleFrequencyObject?.day_of_month);
        }
        else if (payScheduleFrequency === "BI_MONTHLY"){
            payMode = "on the " + numberOrdinalSuffix(payScheduleFrequencyObject?.first_run_day) + " & " + numberOrdinalSuffix(payScheduleFrequencyObject?.second_run_day);
        }
        else if (payScheduleFrequency === "WEEKLY"){
            payMode = "on " + weekdays[payScheduleFrequencyObject?.day_of_week - 1] + "s";
        }

        return ((frequency || "") + " - " + (payMode || ""));
    }


    const submitForm = async (e) => {
        e.preventDefault();

        if (form.monthYear.monthIndex === "" || form.monthYear.year === ""){
            toast.error("Please select the payroll month & year");
        }
        else if (form.payGroup.length === 0){
            toast.error("Please select one or more pay groups");
        }
        else if (form.paySchedule === ""){
            toast.error("Please select a payroll schedule");
        }
        else if (form.payrollType === ""){
            toast.error("Please select a payroll type");
        }
        else{

            const params = {
                type: form.payrollType.toUpperCase(),
                month: parseInt(form.monthYear.monthIndex),
                year: parseInt(form.monthYear.year),
                pay_selection: "PAY_GROUPS",
                pay_group_ids: form.payGroup?.map(payGroup => payGroup.id),
                payroll_schedule_id: form.paySchedule,
            }
            logger("Employer-Payroll-runpayroll-create-payroll-success", userInfo);
            dispatch(payrollAction.createPayroll(params));

        }
    }


    useEffect(() => {
        if (isEnvironment("production") === true){
            setForm({
                ...form,
                payrollType: "net",
            });
        }
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        getPayGroups();
        getPayrollSchedules();
        // eslint-disable-next-line
    }, [location]);


    useEffect(() => {
        if (createPayroll[0] !== undefined){
            toast.success("Payroll created successfully");
            dispatch(payrollAction.resetCreatePayroll());
            history.push("/payroll/" + createPayroll[0]?.id + "/run");
        }
        // eslint-disable-next-line
    }, [createPayroll]);


    return (
        <div>

            <DynamicHeadTag
                headerText="Create Payroll"
                headerDescription=""
            />


            <SelectPayGroup
                isOpen={isOpenPayGroups}
                setIsOpen={setIsOpenPayGroups}
                payGroups={payGroups}
                payGroupsLoading={payGroupsLoading}
                onChange={(e) => addPayGroup(e)}
            />


            <div className="border-b">
                <TabSettings options={[
                    {
                        title: <span>Pay Run</span>,
                        type: "link",
                        url: "/payroll",
                    },
                    {
                        title: <span>Payroll History</span>,
                        type: "link",
                        url: "/payroll/history",
                    },
                ]} />
            </div>


            <form onSubmit={submitForm} className="mt-6">
                <div className="flex flex-col">
                    <div className="py-6 sm:flex sm:space-x-8 sm:justify-between">
                        <div className="flex-grow">
                            <div className="text-lg font-medium">
                                Create Payroll
                            </div>
                            <div className="mt-1 text-sm text-[#6B7280]">
                                Create and configure your payroll per schedule with the predefined pay period
                            </div>
                        </div>
                        <div className="mt-6 sm:mt-0 flex-shrink-0 flex space-x-6 items-center">
                            <ButtonLoader loading={createPayrollLoading} type="submit" className="btn btn-ep-primary">
                                Create Payroll
                            </ButtonLoader>
                            <Link to="/payroll" className="btn btn-white">
                                Cancel
                            </Link>
                        </div>
                    </div>

                    <div className="py-10 border-t border-gray-200">
                        <div className="w-full max-w-4xl sm:flex sm:space-x-8 sm:justify-between">
                            <div className="w-full sm:w-2/5">
                                Payroll Month and year
                            </div>
                            <div className="mt-6 sm:mt-0 w-full sm:w-3/5">
                                <div className="form-group mb-0">
                                    <div className="custom-date-picker">
                                        <DatePicker
                                            selected={form?.monthYear?.fullDate}
                                            renderMonthContent={renderMonthContent}
                                            showMonthYearPicker
                                            dateFormat="MMMM, yyyy"
                                            placeholderText="Select Payroll Month and Year"
                                            className="form-input form-input-lg"
                                            onChange={(date) => monthYearSelection(date)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="py-10 border-t border-gray-200">
                        <div className="w-full max-w-4xl sm:flex sm:space-x-8 sm:justify-between">
                            <div className="w-full sm:w-2/5">
                                Pay Group selection
                            </div>
                            <div className="mt-6 sm:mt-0 w-full sm:w-3/5">
                                <div className="form-group mb-0">
                                    <div className="form-input-lg !h-full !pt-3 bg-white flex flex-wrap items-center">

                                        {form.payGroup?.map(payGroup =>
                                            <div key={payGroup.id} className="w-max mr-3 mb-3 border border-black rounded px-3 py-1.5 my-auto flex space-x-3 items-center justify-between">
                                                <div>
                                                    {payGroup.name}
                                                </div>
                                                <div onClick={() => removePayGroup(payGroup)} className="h-full p-1 ml-2 flex hover:bg-red-500 rounded-md group cursor-pointer">
                                                    <IconsTimes className="w-3 h-3 m-auto group-hover:svg-fill-white" />
                                                </div>
                                            </div>
                                        )}

                                        <div onClick={() => setIsOpenPayGroups(true)} className="w-max mr-3 mb-3 text-ep-primary border border-transparent hover:bg-[#F4F4F4] rounded px-3 py-1.5 my-auto flex items-center cursor-pointer">
                                            <IconsPlus className="w-3 h-3 mr-2 svg-fill-primary" />
                                            Add Pay Group
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="py-10 border-t border-gray-200">
                        <div className="w-full max-w-4xl sm:flex sm:space-x-8 sm:justify-between">
                            <div className="w-full sm:w-2/5">
                                Payroll Schedule
                            </div>
                            <div className="mt-6 sm:mt-0 w-full sm:w-3/5">
                                <Maybe condition={paySchedulesLoading === true}>
                                    <Input type="text" label="" value="Loading payroll schedules..." containerClass="mb-0" inputClass="form-input-lg" disabled={true} />
                                </Maybe>
                                <Maybe condition={paySchedulesLoading === false}>
                                    <SelectInput label="" required={false} containerClass="mb-0" selectClass="form-input-lg" value={form.paySchedule} onChange={(e) => setForm({...form, paySchedule: e.target.value})}>
                                        <option value="">Select payroll schedule</option>
                                        {paySchedules?.data?.map(paySchedule => (
                                            <option key={paySchedule.id} value={paySchedule.id}>
                                                {paySchedule.name} ({getPayScheduleFrequency(paySchedule)})
                                            </option>
                                        ))}
                                    </SelectInput>
                                </Maybe>
                            </div>
                        </div>
                    </div>

                    <div className="py-10 border-t border-gray-200">
                        <div className="w-full max-w-4xl sm:flex sm:space-x-8 sm:justify-between">
                            <div className="w-full sm:w-2/5">
                                Payroll type
                            </div>
                            <div className="mt-6 sm:mt-0 w-full sm:w-3/5">
                                <Environment local={false} develop={true} staging={true} production={false}>
                                    <div className="text-ep-primary mb-3">
                                        Choose preferred payroll style
                                    </div>
                                </Environment>
                                <div className="flex flex-col space-y-3">
                                    <div>
                                        <Checkbox
                                            type="radio"
                                            label="Net Payroll"
                                            checked={form.payrollType === "net"}
                                            onChange={(e) => setForm({...form, payrollType: "net"})}
                                        />
                                    </div>
                                    <Environment local={true} develop={true} staging={true} production={false}>
                                        <div>
                                            <Checkbox
                                                type="radio"
                                                label="Gross Payroll"
                                                checked={form.payrollType === "gross"}
                                                onChange={(e) => setForm({...form, payrollType: "gross"})}
                                            />
                                        </div>
                                    </Environment>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </form>


        </div>
    )
}


const SelectPayGroup = (props) => {
    const {isOpen, setIsOpen, onChange, payGroups, payGroupsLoading} = props;
    
    
    const [payGroup, setPayGroup] = useState("");


    const submitForm = (e) => {
        e.preventDefault();
        const errors = validate({payGroup});
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const selected = payGroups?.data?.filter(data => data.id === payGroup)
            if (selected[0]){
                onChange(selected[0]);
            }
        }
    }


    useEffect(() => {
        if (isOpen === true){
            setPayGroup("");
        }
    }, [isOpen])


    return (
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={submitForm} className="p-8">
                <div className="font-bold text-[#0D0C2B] text-lg sm:text-xl">
                    Add Pay Group
                </div>

                <PageContent
                    loading={payGroupsLoading}
                    data={payGroups}
                    loadingText="Loading pay groups"
                    emptyText="No pay groups yet"
                    errorText="Unable to load pay groups"
                />

                <Maybe condition={payGroupsLoading === false && payGroups?.data}>
                    <div className="mt-8">
                        <SelectInput label="Pay Group" value={payGroup} onChange={(e) => setPayGroup(e.target.value)}>
                            <option value="">Select</option>
                            {payGroups?.data?.map(payGroup => (
                                <option key={payGroup.id} value={payGroup.id}>{payGroup.name}</option>
                            ))}
                        </SelectInput>

                        <div className="-mt-3 text-sm">
                            Can't find your preferred pay group?&nbsp;
                            <Link to="/payroll-configuration/pay-groups" target="_blank" className="text-ep-primary font-medium hover:underline">
                                Create one
                            </Link>
                        </div>

                        <div className="mt-12 flex space-x-3 justify-start">
                            <ButtonLoader type="submit" loading={false} className="btn btn-ep-primary">
                                Add pay group
                            </ButtonLoader>
                            <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-primary">
                                Cancel
                            </button>
                        </div>
                    </div>
                </Maybe>
            </form>
        </FormDrawer>
    )
}


export default Index;